export default "__VITE_ASSET__CO7LeZ$X__"